export default __webpack_public_path__ + "images/242a439dd29ad46f5c4b7b2dbaaa1380.png";